"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingsPage = void 0;
const react_1 = __importStar(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const services_1 = require("../../../common/services");
const Bookings_1 = __importDefault(require("../Booking/Bookings"));
const NotificationPermissions_1 = __importDefault(require("../Notifications/NotificationPermissions"));
const helpers_1 = require("../../../common/helpers/helpers");
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const globalVariables_1 = require("../../../common/globalVariables");
const BookingsPageWrapper = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  background: #fff;

  max-width: ${(props) => props.contentMaxWidth}px;
  margin: auto;

  .Mui-selected {
    color: ${(props) => props.theme.palette ? props.theme.palette.mainAppColor.main : "#FFF"};
  }

  .MuiTabs-indicator {
    background-color: ${(props) => props.theme.palette ? props.theme.palette.mainAppColor.main : "#FFF"};
  }
`;
const BookingList = styled_components_1.default.div `
  max-width: ${(props) => props.contentMaxWidth}px;
  margin: 10px auto;
`;
const LoaderWrapper = styled_components_1.default.div `
  position: relative;
  height: 100px;
`;
const PermisisonWrapper = styled_components_1.default.div `
  position: fixed;
  bottom: 16px;
  width: 100%;
  padding: 0 16px;
  left: 0px;
  display: flex;
  justify-content: center;

  .permission-controls {
    width: 100%;
  }

  @media screen and (min-width: 1000px) {
    .permission-controls {
      width: 700px;
    }
  }
`;
const BookingsPage = (props) => {
    const [value, setValue] = (0, react_1.useState)(0);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [upcomingBookings, setUpcomingBookings] = (0, react_1.useState)([]);
    const [cancelledBookings, setCancelledBookings] = (0, react_1.useState)([]);
    const [pastBookings, setPastBookings] = (0, react_1.useState)([]);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const fetchNewBookings = () => __awaiter(void 0, void 0, void 0, function* () {
        // TO DO : make these 3 calls in parallel
        const upcoming = yield services_1.apiService.getBookingsNew(props.currentLocale, props.userData.token, "upcoming");
        const past = yield services_1.apiService.getBookingsNew(props.currentLocale, props.userData.token, "past");
        const cancelled = yield services_1.apiService.getBookingsNew(props.currentLocale, props.userData.token, "cancelled");
        setUpcomingBookings(upcoming.bookings);
        setCancelledBookings(cancelled.bookings);
        setPastBookings(past.bookings);
        setIsLoading(false);
        return {
            upcoming: upcoming.bookings,
            past: past.bookings,
            cancelled: cancelled.bookings,
        };
    });
    (0, react_1.useEffect)(() => {
        fetchNewBookings().then((bookingGroups) => {
            if (props.match.params.code) {
                const { foundBooking, tabValue } = findBookingInBookingLists(props.match.params.code, bookingGroups);
                if (tabValue) {
                    setValue(tabValue);
                }
                if (foundBooking) {
                    helpers_1.Helpers.openModal(modalEnums_1.default.BOOKING_DETAILS, {
                        booking: foundBooking,
                        fetchNewBookings,
                        redirectOnClose: `${props.baseUrl}/bookings`,
                    });
                }
            }
        });
    }, []);
    (0, react_1.useEffect)(() => {
        if (Object.keys(props.userData).length > 0) {
            fetchNewBookings();
        }
    }, [props.userData]);
    return (react_1.default.createElement(BookingsPageWrapper, { contentMaxWidth: globalVariables_1.WEB_APP.MAX_WIDTH_HEADER },
        react_1.default.createElement(material_1.Box, { sx: { width: "100%" } },
            react_1.default.createElement(material_1.Tabs, { value: value, onChange: handleChange, "aria-label": "booking tabs", variant: "fullWidth", centered: true, sx: {
                    borderBottom: 1,
                    borderColor: "divider",
                    position: "sticky",
                    top: "60px",
                    backgroundColor: "white",
                    zIndex: 1003,
                } },
                react_1.default.createElement(material_1.Tab, { label: i18n_js_1.default.t("upcoming_bookings") }),
                react_1.default.createElement(material_1.Tab, { label: i18n_js_1.default.t("cancelled_bookings") }),
                react_1.default.createElement(material_1.Tab, { label: i18n_js_1.default.t("past_bookings") })),
            isLoading ? (react_1.default.createElement(LoaderWrapper, null,
                react_1.default.createElement(Loader_1.default, null))) : (react_1.default.createElement(BookingList, { contentMaxWidth: globalVariables_1.WEB_APP.MAX_WIDTH_CONTAINER },
                value === 0 && (react_1.default.createElement(Bookings_1.default, { data: upcomingBookings, fetchNewBookings: fetchNewBookings })),
                value === 1 && (react_1.default.createElement(Bookings_1.default, { data: cancelledBookings, fetchNewBookings: fetchNewBookings })),
                value === 2 && (react_1.default.createElement(Bookings_1.default, { data: pastBookings, fetchNewBookings: fetchNewBookings }))))),
        react_1.default.createElement(PermisisonWrapper, null,
            react_1.default.createElement(NotificationPermissions_1.default, null))));
};
exports.BookingsPage = BookingsPage;
function findBookingInBookingLists(bookingCode, bookingLists) {
    let foundBooking = null;
    let category = "";
    Object.keys(bookingLists).forEach((bookingListName) => {
        bookingLists[bookingListName].forEach((subgroup) => {
            subgroup.bookings.forEach((booking) => {
                if (booking.code === bookingCode) {
                    foundBooking = booking;
                    category = bookingListName;
                }
            });
        });
    });
    let tabValue = null;
    if (category === "upcoming") {
        tabValue = 0;
    }
    if (category === "cancelled") {
        tabValue = 1;
    }
    if (category === "past") {
        tabValue = 2;
    }
    return { foundBooking, tabValue };
}
const mapStoreToProps = (store) => ({
    baseUrl: store.getValue("baseUrl"),
    currentLocale: store.getValue("currentLocale"),
    userData: store.getValue("userData"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.BookingsPage);
